<div class="div-arriere-plan-action" (click)="clicAction($event)"></div>
<div [ngClass]="isMobile ? 'div-global-action-mob' : ''" class="div-global-action flex-col"
  (click)="clicAction($event)">
  <div id="center-square" class="w-full">
    <div>
      <p class="text-xxl bold dark-blue text-center">Important</p>
      <p class="text-lg dark-blue no-margin text-center">Confirmez-vous la validation de votre choix de vote ?
      </p>
      <p class="dark-blue text-md no-margin text-center" *ngIf="!isTestModeActive">
        (Votre choix ne pourra plus être modifié ni annulé)</p>
    </div>

    <div class="w-full">
      <div *ngIf="testDisplayedCandidates" class="w-full ballot-preview w-full mb-10">
        <p class="dark-blue">
          {{electionTitle}} >
          <img src="{{listImage}}" alt="list-icon" class="icon" *ngIf="listImage != undefined && listImage !== ''"
            width="40px">
          <span class="bold" style="margin-left: 10px;">{{listName}}</span>
        </p>
        <div class="candidates-holder">
          <p *ngFor="let candidate of testDisplayedCandidates" class="dark-blue text-center no-margin"
            [ngStyle]="{'text-decoration': candidate.selected === false ? 'line-through' : 'none'}">{{candidate.name}}
          </p>
        </div>
      </div>
      <p class="dark-blue text-center break-word">Voici le chiffré de votre bulletin : <br>{{sha}}</p>
    </div>


    <div class="flex-col gap-10 w-full align-items-center">
      <button class="action-button min-button" (click)="confirmVote(true)">Confirmer</button>
      <button class="cancel-button min-button" (click)="confirmVote(false)">Annuler</button>
    </div>

    <!-- <p class="dark-blue text-md no-margin text-center pointer" (click)="cancelDetails(false)">Fermer</p> -->

  </div>
</div>